import { skipToken } from '@reduxjs/toolkit/query';
import { useGetTradesQuery } from '@/store/api';

export function useProfilePreviewTrades(
	previewUserId: string | undefined,
	user: any,
	lobby: any,
	currentUserTrades: any[]
) {
	const isOtherUser = !!previewUserId && previewUserId !== user?.id && !!user?.id;

	const { data: fetchedTrades = [] } = useGetTradesQuery(
		isOtherUser && lobby?.id ? { user_id: previewUserId!, lobby_id: lobby.id } : skipToken
	);

	return isOtherUser ? fetchedTrades : currentUserTrades;
}
